import CadastroForm from "./CadastroForm";

export default CadastroForm;
